module.exports = __webpack_public_path__ + "images/mailchimp/dropdown.png";